export default {
    methods: {

    }
};
